<template>
  <div class="background_manage_background">
    <!-- 上部导航栏样式 -->
    <div class="main_topnav config_main_manage_topnav">
      <top-nav class="main_topnav">
        <top-nav-item
          class="left_item"
          @click.native="shareManageReturnBtnHandle"
        >
          <img
            class="main_top_img"
            slot="topnavimg"
            src="~assets/img/topnav/zuofanhui.png"
            alt
          />
          <div slot="topimgtext">返回</div>
        </top-nav-item>
        <top-nav-item>
          <div slot="topimgtext">背景管理</div>
        </top-nav-item>
        <top-nav-item >

        </top-nav-item>
      </top-nav>
    </div>

    <!-- 设置页面的内容区域 -->
    <div class="background_manage_page_wraper">
      <div class="background_manage_page_content">
       <config-title-hang >
        <span slot="config_title_hang_ele2">可选背景</span>
      </config-title-hang>
          <div class="background_select_wraper">
            <!-- 系统默认的不可去除修改的 -->
            <div @click="selectBackgroundBtnHandle('1')" :class="backgroundState === '1'? 'one_background_select':'' "  class="one_background control_background_seytem">
              <img v-if="backgroundState === '1'" class="one_background_select_img" src="../../../assets/img/config/xuanzhong.png" alt="">
                      <!-- 文字描述 -->
              <div class="one_background_text">系统默认（经典蓝）</div>
            </div>

              <!-- 动态样式1 -->
              <div @click="selectBackgroundBtnHandle('2')" :class="backgroundState === '2'? 'one_background_select':''" class="one_background ">
                  <!-- 背景内容区，在此添加时应在bass.css和 controlPage页面同时添加 -->
                  <div class="currency_background_vue_dongxiao">
                       <img v-if="backgroundState === '2'" class="one_background_select_img" 
                          src="../../../assets/img/config/xuanzhong.png" alt="">
              			    <div id='stars'></div>
			                  <div id='stars2'></div>
		              	    <div id='stars3'></div>
                  </div>
                      <!-- 文字描述 -->
                 <div class="one_background_text">动态星空蓝</div>
                </div>

              </div>


           </div>
    </div>
  </div>
</template>

<script>
import topNav from 'components/common/topnav/topnav'
import topNavItem from 'components/common/topnav/topnavitem'
import configTitleHang from 'components/common/config/config-title-hang'

export default {
  data() {
    return {
      backgroundState: sessionStorage.getItem('backgroundSelectState')
    }
  },
  components: {
    topNav,
    topNavItem,
    configTitleHang
  },
  methods: {
    shareManageReturnBtnHandle() {
      this.$router.go(-1)
    },
    backgroundSelectState() {
      //背景的选择状态
      if (localStorage.getItem('backgroundSelectState') === null) {
        console.log('用户还没有设置背景')
        localStorage.setItem('backgroundSelectState', '1')
      }
      ////把本地缓存拿到浏览器缓存，方便调用
      sessionStorage.setItem(
        'backgroundSelectState',
        localStorage.getItem('backgroundSelectState')
      )
    },
    selectBackgroundBtnHandle(data) {
      this.backgroundState = data ///更新选择
      localStorage.setItem('backgroundSelectState', data) ////存入本地缓存
      ////把本地缓存拿到浏览器缓存，方便调用
      sessionStorage.setItem(
        'backgroundSelectState',
        localStorage.getItem('backgroundSelectState') ///存入浏览器缓存
      )
    }
  },
  mounted() {
    console.log('mounted阶段')
  },
  created() {
    console.log('created阶段')
  }
}
</script>

<style>
/* 外包装部分 */
.background_manage_page_wraper {
  max-width: 1200px;
  height: 100%;
  margin: 0 auto; /* 屏幕居中，上下0px  左右自动居中 */
  border-radius: 5px;
  /* box-shadow: 0 0 1px var(--primary-color); */
  box-sizing: border-box;
  padding-top: 0px;
  padding-left: 20px;
  padding-right: 20px;

  /* background: url('../../../assets/img/background/background1.png');
    background-size: 100% auto;  */
  /* 火狐浏览器滚动条隐藏 */
  overflow: auto;
  overflow-y: scroll;
  scrollbar-color: transparent transparent;
  scrollbar-track-color: transparent;
  -ms-scrollbar-track-color: transparent;
}

/* Chrome 和 Safari滚动条隐藏 */
.background_manage_page_wraper::-webkit-scrollbar {
  display: none;
}
/* 背景颜色 */
.background_manage_background {
  width: 100%;
  height: 100%;
  position: relative;
  /* background-color: tomato; */
  z-index: -2;

  /* background: linear-gradient(rgb(161, 145, 231), blue);
    background: -webkit-linear-gradient(rgb(161, 145, 231), blue);
    background: -o-linear-gradient(rgb(161, 145, 231), blue); 
    background: -moz-linear-gradient(rgb(161, 145, 231), blue); */
}

.background_manage_page_content {
  /* ////  使内容区高一点以便滚动条的滑动 */
  margin-bottom: 500px;
}

.background_select_wraper {
  width: 100%;
  position: relative;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  /* align-content: center; */
}
.one_background {
  position: relative;
  width: 400px;
  height: 250px;
  border: 1px solid #dddddd;

  border-radius: 5px;
  cursor: pointer;
  /* flex-shrink: 0; */
  margin: 40px 80px;
}
.one_background_select {
  border: 2px solid #282828;
}
.one_background_select_img {
  height: 24px;
  width: 24px;
  margin: 10px 10px;
}
.one_background_text {
  color: #282828;
  font-size: 18px;

  width: 100%;
  position: absolute;
  bottom: -40px;
  left: 0px;
  text-align: center;
}
</style>
